export default __webpack_public_path__ + "static/media/info_hotel.a6a00166.svg";